import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { BsgBall } from '../../api/models';

export type TABLE_TYPE = Table<BsgBall>;

export const TABLE = 'bsgBall';
const SCHEMA = 'bsgBallId, sortId';

class BsgBallDatabase implements DataRepository<BsgBall> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<BsgBall | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: BsgBall, key: Key): Promise<BsgBall> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: BsgBall[]): Promise<BsgBall[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<BsgBall[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const BsgBallDB = new BsgBallDatabase(db);
